<div [class.has-icon]="this.imageUrl() || svgIcon()"
     [class.is-checked]="checked()"
     [class.is-hiding-selection-boxes]="isHidingSelectionBoxes()"
     [class.is-loading]="isLoading()"
     class="wrapper">
    @let idValue = id();
    <input #inputElement (change)="onChange(inputElement.checked)"
           [attr.data-qa]="qaTag() + '-input'+((checked()) ? '-checked':'')"
           [attr.name]="name() + (isMultiSelect() ? '[]' : '')"
           [attr.type]="isMultiSelect() ? 'checkbox' : 'radio'"
           [checked]="checked()"
           [disabled]="disabled()"
           [id]="idValue"
           [value]="idValue"
           class="item-input">
    <label [attr.data-qa]="qaTag() + '-label'+((checked()) ? '-checked':'')" [for]="idValue" class="item-label">
        @let imageUrl = this.imageUrl();
        @if (imageUrl) {
            <app-virtual-scroll-list-item-icon [alt]="imageUrl.alt"
                                               [attr.data-qa]="qaTag() + '-label-icon'"
                                               [attr.title]="imageUrl.title || null"
                                               [defaultIcon]="this.defaultIcon()"
                                               [url]="imageUrl.url"
                                               aria-hidden="true"
                                               class="item-icon"/><!--// TODO: Umstellen auf app-icon //-->
        } @else if (svgIcon()) {
            <app-icon [iconSize]="AppIconSize.MEDIUM" [svgIcon]="svgIcon()" aria-hidden="true" class="item-icon"></app-icon>
        }
        <div [attr.data-qa]="qaTag() + '-label-text'" class="item-text">
            @if (label()) {
                {{ label() }}
            } @else {
                <ng-content/>
            }
        </div>
        @if (!isHidingSelectionBoxes()) {
            @if (checked()) {
                <app-icon [iconSize]="AppIconSize.SMALL" [svgIcon]="ICONS.OPTION_YES" aria-hidden="true" class="item-selected-icon"/>
            } @else {
                <app-icon [iconSize]="AppIconSize.SMALL" [svgIcon]="ICONS.OPTION_EMPTY" aria-hidden="true" class="item-select-icon"/>
            }
        }
    </label>
</div>
@if (isLoading()) {
    <app-loading-spinner [attr.data-qa]="qaTag() + '-loading-spinner'" class="server-loading-spinner"/>
}
